export const isSameSubRoute = (first, second) =>
  !!first &&
  !!second &&
  ((first.lat === second.lat && first.lng === second.lng) ||
    first.name.trim().toLowerCase() === second.name.trim().toLowerCase());

export const hasConsecutiveSubRoutes = (routes) =>
  routes.some(
    (route, index) => index > 0 && isSameSubRoute(routes[index - 1], route),
  );
